import { render } from "./Sample.vue?vue&type=template&id=6e791abd&ts=true"
import script from "./Sample.vue?vue&type=script&lang=ts"
export * from "./Sample.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__